import { render, staticRenderFns } from "./DropdownCard.vue?vue&type=template&id=0cfba475&scoped=true"
import script from "./DropdownCard.vue?vue&type=script&lang=ts"
export * from "./DropdownCard.vue?vue&type=script&lang=ts"
import style0 from "./DropdownCard.vue?vue&type=style&index=0&id=0cfba475&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfba475",
  null
  
)

export default component.exports